import { useContext } from 'react';

import { BackendContext } from 'dashboard/components/GraphModule/GraphCanvasContextProvider';
import { Backend } from 'dashboard/models/graph-backend';

// In order for this hook to function, it must be preceded by a GraphContextWrapper
export const useBackend = (backendRef?: React.MutableRefObject<Backend> | null) => {
  const backend = useContext(BackendContext);

  if (backendRef) {
    backendRef.current = backend;
  }

  return backend;
};
